import {
  FETCH_SEARCH_POSTS_RESULTS,
  FETCH_SEARCH_POSTS_RESULTS_SUCCESS,
  FETCH_SEARCH_POSTS_RESULTS_FAILURE,
  FETCH_SEARCH_COMMUNITIES_RESULTS,
  FETCH_SEARCH_COMMUNITIES_RESULTS_SUCCESS,
  FETCH_SEARCH_COMMUNITIES_RESULTS_FAILURE,
  FETCH_SEARCH_MEMBERS_RESULTS,
  FETCH_SEARCH_MEMBERS_RESULTS_SUCCESS,
  FETCH_SEARCH_MEMBERS_RESULTS_FAILURE,
  SET_SEARCH_SORT_BY,
  SET_COMMUNITY_FILTER,
  RESET_QUERY,
} from './actionTypes';

export const initialState = {
  communityFilter: 'all',
  communityFilterOptions: [],
  communityResults: [],
  membersResults: [],
  sortBy: 'most-relevant',
  searchQuery: '',
  searchResults: [],
  isLoading: true,
  currentPage: 1,
  totalResults: 0,
  searchId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SEARCH_POSTS_RESULTS:
      return {
        ...state,
        searchQuery: action.query,
        currentPage: action.currentPage,
        communityFilter: action.communityFilter,
        searchResults: [],
        sortBy: action.sortBy,
        // Solves the issue of setting a blank query
        isLoading: !!action.query,
        searchId: action.searchId,
      };
    case FETCH_SEARCH_POSTS_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        searchResults: action.results,
        communityFilterOptions: action.communityFilterOptions,
        totalResults: action.totalResults,
      };
    case FETCH_SEARCH_POSTS_RESULTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case FETCH_SEARCH_COMMUNITIES_RESULTS:
      return {
        ...state,
        currentPage: action.currentPage,
        searchQuery: action.query,
        communityResults: [],
        // Solves the issue of setting a blank query
        isLoading: !!action.query,
        searchId: action.searchId,
      };
    case FETCH_SEARCH_COMMUNITIES_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        communityResults: action.results,
        totalResults: action.totalResults,
      };
    case FETCH_SEARCH_COMMUNITIES_RESULTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case FETCH_SEARCH_MEMBERS_RESULTS:
      return {
        ...state,
        searchQuery: action.query,
        currentPage: action.currentPage,
        communityFilter: action.communityFilter,
        membersResults: [],
        // Solves the issue of setting a blank query
        isLoading: !!action.query,
        searchId: action.searchId,
      };
    case FETCH_SEARCH_MEMBERS_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        membersResults: action.membersResults,
        totalResults: action.totalResults,
      };
    case FETCH_SEARCH_MEMBERS_RESULTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case SET_SEARCH_SORT_BY:
      return {
        ...state,
        sortBy: action.sortBy,
      };
    case SET_COMMUNITY_FILTER:
      return {
        ...state,
        communityFilter: action.communityId,
      };
    case RESET_QUERY:
      return {
        ...state,
        searchQuery: '',
      };
    default:
      return state;
  }
};

export default reducer;
